// src/components/LandingPage/InnovationDNA.tsx
import React from "react";
import { dnaCards } from "./data";

export default function Innovation() {
  return (
    <section id="innovation-dna"
      className="py-12 lg:py-20"
      style={{
        backgroundImage:
          "linear-gradient(152.498deg, rgb(238,251,255) 0%, rgb(219,234,254) 50%, rgb(238,251,255) 100%)",
      }}
    >
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">

        <div>
          <h2 className="text-center text-2xl sm:text-3xl lg:text-[48px] leading-tight font-normal text-[#171a22] mb-4 lg:mb-8">
            Our Innovation DNA
          </h2>

          <p className="text-center mx-auto text-base sm:text-lg lg:text-[24px] leading-relaxed font-light text-[#171a22] max-w-[875px] mb-10 lg:mb-16">
            We are a community focused on empowering innovation and collaboration. Our goal is to create
            opportunities for people to explore ideas and build meaningful solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {dnaCards.map((item, i) => {
            // Normalize iconPath to an array of strings so we can safely .map()
            const dList = Array.isArray(item.iconPath)
              ? item.iconPath
              : [item.iconPath];

            return (
              <div key={i} className="text-center bg-white border border-[#eff0f4] p-6 lg:p-10">
                <div className="w-12 h-12 lg:w-14 lg:h-14 mb-6 lg:mb-8 mx-auto">
                  <svg className="w-full h-full" fill="none" viewBox={item.viewBox}>
                    {dList.map((d, idx) => (
                      <path
                        key={idx}
                        d={d}
                        // If item.fill exists, render as filled; else fall back to stroked
                        {...(item.fill
                          ? { fill: item.fill }
                          : { fill: "none", stroke: item.stroke ?? "#171A22" })}
                        {...(item.strokeWidth ? { strokeWidth: item.strokeWidth } : {})}
                        {...(item.linecap ? { strokeLinecap: item.linecap } : {})}
                        {...(item.linejoin ? { strokeLinejoin: item.linejoin } : {})}
                      />
                    ))}
                  </svg>
                </div>

                <h3 className="text-lg lg:text-[24px] leading-snug font-normal text-[#171a22] mb-3 lg:mb-4">
                  {item.title}
                </h3>
                <p className="text-sm lg:text-base leading-relaxed font-light text-[#171a22] mb-4 lg:mb-6">
                  {item.desc}
                </p>

                <button className="mx-auto flex items-center gap-2 text-[#1d365a] text-sm lg:text-base font-medium group">
                  {item.cta}
                  <svg
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    viewBox={item.arrowViewBox}
                  >
                    <path
                      d={item.arrowPath}
                      stroke="#1D365A"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.18"
                    />
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}